import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidDictationVisual } from '../../../../mechanics/rid-dictation-visual/rid-dictation-visual';

@Component({
  selector: 'app-dictation-visual-page',
  imports: [RidDictationVisual],
  templateUrl: './dictation-visual-page.html',
})
export class DictationVisualPage {
  protected readonly $router = inject(Router);
}
